export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'other', label: 'Other' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
];

export const INTERESTED_IN_OPTIONS = [
  { value: 'men', label: 'Men' },
  { value: 'women', label: 'Women' },
  { value: 'non-binary', label: 'Non-binary' },
  { value: 'all', label: 'All genders' },
];

export const USER_INTERESTS = [
  { value: 'emotional_support', label: 'Emotional Support', emoji: '🤝' },
  { value: 'gaming', label: 'Gaming', emoji: '🎮' },
  { value: 'coffee_meet', label: 'Coffee Meet', emoji: '☕' },
  { value: 'movies', label: 'Movies', emoji: '🎬' },
  { value: 'travel', label: 'Travel', emoji: '✈️' },
  { value: 'chill_chat', label: 'Chill Chat', emoji: '💬' },
  { value: 'romantic', label: 'Romantic', emoji: '❤️' },
  { value: 'study_buddy', label: 'Study Buddy', emoji: '📚' },
  { value: 'fitness', label: 'Fitness', emoji: '💪' },
  { value: 'late_night_talks', label: 'Late Night Talks', emoji: '🌙' },
];

export const HOBBIES = [
  { value: 'cooking', label: 'Cooking', emoji: '🍳' },
  { value: 'reading', label: 'Reading', emoji: '📖' },
  { value: 'photography', label: 'Photography', emoji: '📸' },
  { value: 'dancing', label: 'Dancing', emoji: '💃' },
  { value: 'music', label: 'Music', emoji: '🎵' },
  { value: 'sports', label: 'Sports', emoji: '⚽' },
  { value: 'art', label: 'Art', emoji: '🎨' },
  { value: 'tech', label: 'Tech', emoji: '💻' },
  { value: 'hiking', label: 'Hiking', emoji: '🥾' },
  { value: 'yoga', label: 'Yoga', emoji: '🧘' },
];

export const LOOKING_FOR_OPTIONS = [
  { value: 'long_term', label: 'Long-term Partner', emoji: '💍' },
  { value: 'short_term', label: 'Short-term Fun', emoji: '🎉' },
  { value: 'new_friends', label: 'New Friends', emoji: '👋' },
  { value: 'casual', label: 'Casual Connection', emoji: '🥂' },
  { value: 'not_sure', label: 'Not Sure Yet', emoji: '🤔' },
];

export const HIRE_A_FRIEND_SERVICES = [
  { value: 'coffee_meetup', label: 'Coffee Meetup' },
  { value: 'gaming_partner', label: 'Gaming Partner' },
  { value: 'study_buddy', label: 'Study Buddy' },
  { value: 'emotional_support', label: 'Emotional Support' },
  { value: 'travel_buddy', label: 'Travel Buddy' },
  { value: 'movie_partner', label: 'Movie Partner' },
  { value: 'shopping_partner', label: 'Shopping Partner' },
  { value: 'karaoke_buddy', label: 'Karaoke Buddy' },
];

export const SEXUAL_PREFERENCES_HIRE_A_FRIEND = [
  '☕ Casual Coffee Chat',
  '🎮 Gaming Partner (text-based)',
  '📚 Study Together / Work Buddy',
  '📽️ OTT Movie Discussions',
  '🧘 Stress Relief Chat',
  '🎶 Music Jam Session',
  '🧠 Mental Boost & Motivation Chat',
  '📖 Book Club Chat',
  '✈️ Travel Experience Sharing',
  '💬 Daily Texting Partner',
];

export const FWB_SERVICES = [
  { value: 'flirty_chat', label: 'Flirty Chat' },
  { value: 'romantic_bonding', label: 'Romantic Bonding' },
  { value: 'late_night_talks', label: 'Late Night Talks' },
  { value: 'virtual_relationship', label: 'Virtual Relationship' },
  { value: 'personalized_texting', label: 'Personalized Texting' },
  { value: 'roleplay_chat', label: 'Roleplay Chat' },
];

export const PERSONALITY_TRAITS = [
  { value: 'introvert', label: 'Introvert', emoji: '🏠' },
  { value: 'extrovert', label: 'Extrovert', emoji: '🎭' },
  { value: 'ambivert', label: 'Ambivert', emoji: '⚖️' },
  { value: 'funny', label: 'Funny', emoji: '😂' },
  { value: 'sarcastic', label: 'Sarcastic', emoji: '😏' },
  { value: 'kind', label: 'Kind', emoji: '😇' },
  { value: 'nerdy', label: 'Nerdy', emoji: '🤓' },
  { value: 'chill', label: 'Chill', emoji: '😎' },
];
